'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _proptypes = require('../util/proptypes');

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _palette = require('../../palette');

require('./hover-icon.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var HoverIcon = function (_Component) {
  _inherits(HoverIcon, _Component);

  function HoverIcon() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HoverIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HoverIcon.__proto__ || Object.getPrototypeOf(HoverIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHover: false,
      isPressing: false
    }, _this.onHover = function (on) {
      _this.setState({
        isHover: on
      });

      _this.props.onHover && _this.props.onHover(on);
    }, _this.onClick = function (e) {
      var _this$props = _this.props,
          stopPropagation = _this$props.stopPropagation,
          onClick = _this$props.onClick,
          onPress = _this$props.onPress;
      if (stopPropagation) e.stopPropagation();
      onPress && onPress(e);
      onClick && onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HoverIcon, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          altTag = _props.altTag,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          containerStyle = _props.containerStyle,
          defaultColor = _props.defaultColor,
          defaultHoverColor = _props.defaultHoverColor,
          defaultPressColor = _props.defaultPressColor,
          defaultImg = _props.defaultImg,
          height = _props.height,
          hoverColor = _props.hoverColor,
          hoverIconRef = _props.hoverIconRef,
          hoverImg = _props.hoverImg,
          Icon = _props.Icon,
          onHover = _props.onHover,
          onBlur = _props.onBlur,
          onClick = _props.onClick,
          _onMouseDown = _props.onMouseDown,
          _onMouseUp = _props.onMouseUp,
          onPress = _props.onPress,
          onPressIn = _props.onPressIn,
          onPressOut = _props.onPressOut,
          pressColor = _props.pressColor,
          pressImg = _props.pressImg,
          size = _props.size,
          stopPropagation = _props.stopPropagation,
          style = _props.style,
          testID = _props.testID,
          titleTag = _props.titleTag,
          width = _props.width,
          others = _objectWithoutProperties(_props, ['altTag', 'children', 'className', 'color', 'containerStyle', 'defaultColor', 'defaultHoverColor', 'defaultPressColor', 'defaultImg', 'height', 'hoverColor', 'hoverIconRef', 'hoverImg', 'Icon', 'onHover', 'onBlur', 'onClick', 'onMouseDown', 'onMouseUp', 'onPress', 'onPressIn', 'onPressOut', 'pressColor', 'pressImg', 'size', 'stopPropagation', 'style', 'testID', 'titleTag', 'width']);

      var _state = this.state,
          isHover = _state.isHover,
          isPressing = _state.isPressing;
      var hoverImageToShow = isHover && hoverImg ? hoverImg : defaultImg;
      var hoverColorToShow = isHover ? hoverColor || defaultHoverColor : color || defaultColor;
      var svgProps = {
        color: isPressing ? pressColor || defaultPressColor : hoverColorToShow
      };
      if (size || height) svgProps.height = size || height;
      if (size || width) svgProps.width = size || width;
      var props = {
        style: style,
        src: isPressing && pressImg ? pressImg : hoverImageToShow,
        alt: altTag,
        title: titleTag,
        'data-testid': testID
      };
      return _react2.default.createElement(_button2.default, _extends({
        className: (0, _classnames2.default)(_defineProperty({
          'zk-hover-icon': true
        }, className, !!className)),
        onBlur: onBlur,
        onClick: this.onClick,
        onPress: this.onClick,
        onMouseDown: function onMouseDown(e) {
          if (stopPropagation) e.stopPropagation();

          _this2.setState({
            isPressing: true
          });

          _onMouseDown && _onMouseDown(e);
          onPressIn && onPressIn(e);
        },
        onMouseUp: function onMouseUp(e) {
          if (stopPropagation) e.stopPropagation();

          _this2.setState({
            isPressing: false
          });

          _onMouseUp && _onMouseUp(e);
          onPressOut && onPressOut(e);
        },
        onMouseEnter: function onMouseEnter() {
          return _this2.onHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.onHover(false);
        },
        ref: hoverIconRef,
        style: containerStyle,
        transparent: true
      }, others), Icon ? _react2.default.createElement('div', props, _react2.default.createElement(Icon, svgProps)) : null, children);
    }
  }]);

  return HoverIcon;
}(_react.Component);

HoverIcon.displayName = 'HoverIcon';
HoverIcon.propTypes = {
  style: _proptypes.STYLE_PROP,
  defaultImg: _propTypes2.default.string,
  hoverImg: _propTypes2.default.string,
  onPress: _propTypes2.default.func,
  fontSize: _propTypes2.default.number
};
HoverIcon.defaultProps = {
  defaultColor: _palette.iconColor,
  defaultHoverColor: _palette.iconHoverColor,
  defaultPressColor: _palette.iconPressColor,
  stopPropagation: false
};
exports.default = HoverIcon;